import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
import { SlingoConstants } from "../enum/SlingoConstants";
import { SymbolConfigData } from "./SymbolConfigData";
/*
 * ReelSequenceData.ts
 */
export class ReelSequenceData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.solidifySymbols();
            this.coinIndexes = this.data.getNumberArray(SlingoConstants.PROPERTY_COIN_INDEXES);
            this.freeSpinIndexes = this.data.getNumberArray(SlingoConstants.PROPERTY_FREE_SPIN_INDEXES);
            this.jokerIndexes = this.data.getNumberArray(SlingoConstants.PROPERTY_JOKER_INDEXES);
            this.superJokerIndexes = this.data.getNumberArray(SlingoConstants.PROPERTY_SUPER_JOKER_INDEXES);
            this.devilIndexes = this.data.getNumberArray(SlingoConstants.PROPERTY_DEVIL_INDEXES);
            this.collectableIndexes = this.data.getNumberArray(SlingoConstants.PROPERTY_COLLECTABLE_INDEXES);
            this.bonusIndexes = this.data.getNumberArray(SlingoConstants.PROPERTY_BONUS_INDEXES);
            this.jokerAndSuperJokerIndexes = this.jokerIndexes.concat(this.superJokerIndexes).sort(this.sortNumber);
        }
    }
    solidifySymbols() {
        let symbols = this.data.getStringArray(SlingoConstants.PROPERTY_SYMBOLS);
        if (this.dataExists(symbols)) {
            this.symbols = [];
            for (let i = 0; i < symbols.length; i++) {
                this.symbols.push(SymbolConfigData.getSymbol(symbols[i]));
            }
        }
    }
    getSymbols() {
        return this.symbols?.slice();
    }
    getCoinIndexes() {
        return this.coinIndexes?.slice();
    }
    getFreeSpinIndexes() {
        return this.freeSpinIndexes?.slice();
    }
    getJokerIndexes() {
        return this.jokerIndexes?.slice();
    }
    getSuperJokerIndexes() {
        return this.superJokerIndexes?.slice();
    }
    getJokerAndSuperJokerIndexes() {
        return this.jokerAndSuperJokerIndexes?.slice();
    }
    getDevilIndexes() {
        return this.devilIndexes?.slice();
    }
    getCollectableIndexes() {
        return this.collectableIndexes?.slice();
    }
    getBonusIndexes() {
        return this.bonusIndexes?.slice();
    }
    hasCoin() {
        return this.coinIndexes.length > 0;
    }
    hasFreeSpin() {
        return this.freeSpinIndexes.length > 0;
    }
    hasJoker() {
        return this.jokerIndexes.length > 0;
    }
    hasSuperJoker() {
        return this.superJokerIndexes.length > 0;
    }
    hasDevil() {
        return this.devilIndexes.length > 0;
    }
    hasCollectable() {
        return this.collectableIndexes.length > 0;
    }
    hasBonus() {
        return this.bonusIndexes.length > 0;
    }
    hasFeature() {
        return this.hasDevil() || this.hasJoker() || this.hasSuperJoker() || this.hasCoin() || this.hasFreeSpin() || this.hasCollectable() || this.hasBonus();
    }
    sortNumber(a, b) {
        return a - b;
    }
}
//# sourceMappingURL=ReelSequenceData.js.map